import { Select, Popover, Icon } from "antd";
import * as React from "react";
import _ from "lodash";
const Option = Select.Option;
import Feature from "../../../../common/components/Feature";
import "./style.scss";

interface ViewSelectProps {
  initial_selection_key?: string;
  metric: string;
  onMenuSelect?: (metric: string) => void;
}

export default class ViewSelect extends React.Component<ViewSelectProps, {}> {
  shouldComponentUpdate(nextProps: any, nextState: any) {
    return !_.isEqual(this.props, nextProps);
  }

  componentWillReceiveProps(nextProps: any) {
    this.setState({ force_refresh: this.props.metric != nextProps.metric });
  }

  handleSelection(key: string) {
    if (this.props.onMenuSelect) {
      this.props.onMenuSelect(key == "null_view" ? null : view_key_map[key]);
    }
  }

  renderOptions() {
    let optionItems: any = [];
    (Object as any)
      .entries(getViewItems(this.props.metric))
      .map((option: any) => {
        optionItems.push(<Option key={option[0]}>{option[1]}</Option>);
      });
    return optionItems;
  }

  validateSelection() {
    let menuItems = getViewItems(this.props.metric);
    if (menuItems[view_name_map[this.props.initial_selection_key]]) {
      return view_name_map[this.props.initial_selection_key];
    } else {
      return _.keys(menuItems)[0];
    }
  }

  render() {
    return (
      <div className="view-select" id="view-select">
        <Select
          size="default"
          placeholder="Select Visualization"
          style={{ width: "100%" }}
          value={this.validateSelection()}
          onChange={this.handleSelection.bind(this)}
        >
          {this.renderOptions()}
        </Select>
      </div>
    );
  }
}

export const getViewItems = (metric: string) => {
  let menu_items_object: any = {};
  let bar_item_contents = getBar(metric);
  let line_item_contents = getLine(metric);
  let pie_item_contents = getPie(metric);
  let map_item_contents = getMap(metric);
  let content_item_contents = getContent(metric);
  let table_item_contents = getTable(metric);

  if (bar_item_contents) {
    menu_items_object = { ...menu_items_object, bar_view: bar_item_contents };
  }
  if (line_item_contents) {
    menu_items_object = { ...menu_items_object, line_view: line_item_contents };
  }
  if (pie_item_contents) {
    menu_items_object = { ...menu_items_object, pie_view: pie_item_contents };
  }
  if (map_item_contents) {
    menu_items_object = { ...menu_items_object, map_view: map_item_contents };
  }
  if (content_item_contents) {
    menu_items_object = {
      ...menu_items_object,
      content_view: content_item_contents
    };
  }
  if (table_item_contents) {
    menu_items_object = {
      ...menu_items_object,
      table_view: table_item_contents
    };
  }

  return menu_items_object;
};

const optionElement = (name: string, hoverContents?: JSX.Element) => {
  const iconName = name == "map" ? "region" : name;
  const icon = <img src={`/icon_${iconName.toLowerCase()}.svg`} />;

  const viewName = ["bar", "line", "pie"].includes(name)
    ? name + " Graph"
    : name;
  return (
    <div className="view-option">
      {icon}
      <div className="view-text">{_.startCase(viewName)}</div>
      {hoverContents}
    </div>
  );
};

const getBar = (metric: string): any => {
  let menu_content = optionElement("bar");
  let isSupported = false;
  switch (metric) {
    case "impressions":
    case "opens":
    case "unique_engaged_visits":
    case "clicks":
    case "average_time_on_flyer":
    case "spend":
    case "shopping_list":
    case "item_views":
    case "ttm":
      isSupported = true;
      break;
    default:
      break;
  }

  return isSupported ? menu_content : null;
};

const getLine = (metric: string): any => {
  let menu_content = optionElement("line");
  let isSupported = false;

  switch (metric) {
    case "impressions":
    case "opens":
    case "unique_engaged_visits":
    case "clicks":
    case "average_time_on_flyer":
    case "spend":
    case "item_views":
      isSupported = true;
      break;
    default:
      break;
  }

  return isSupported ? menu_content : null;
};

const getPie = (metric: string): any => {
  let menu_content = optionElement("pie");
  let isSupported = false;

  switch (metric) {
    case "impressions":
    case "opens":
    case "unique_engaged_visits":
    case "clicks":
    case "average_time_on_flyer":
    case "spend":
    case "shopping_list":
    case "item_views":
    case "ttm":
      isSupported = true;
      break;
    default:
      break;
  }

  return isSupported ? menu_content : null;
};

const getMap = (metric: string): any => {
  let menu_content = optionElement("map");
  let isSupported = false;

  switch (metric) {
    case "opens":
    case "unique_engaged_visits":
    case "ttm":
    case "clicks":
      isSupported = true;
      break;
    default:
      break;
  }

  return isSupported ? menu_content : null;
};

const getContent = (metric: string): any => {
  const getContainer = () => {
    return document.getElementById("view-select");
  };

  const popover = (
    <Feature flag="storefronts_reporting">
      <Popover
        overlayStyle={{ zIndex: 2000 }}
        getTooltipContainer={getContainer}
        arrowPointAtCenter
        placement="topRight"
        title="Help"
        trigger="hover"
        content={CONTENT_HOVER_CONTENTS}
      >
        <Icon type="question-circle" style={{ marginLeft: 63 }} />
      </Popover>
    </Feature>
  );

  let menu_content = optionElement("content", popover);
  let isSupported = false;

  switch (metric) {
    case "clicks":
    case "item_views":
    case "ttm":
    case "shopping_list":
      isSupported = true;
      break;
    default:
      break;
  }

  return isSupported ? menu_content : null;
};

const getTable = (metric: string): any => {
  let menu_content = optionElement("table");
  let isSupported = false;

  switch (metric) {
    case "spend":
      isSupported = true;
      break;
    default:
      break;
  }

  return isSupported ? menu_content : null;
};

export const view_name_map: any = {
  content: "content_view",
  map: "map_view",
  bar: "bar_view",
  line: "line_view",
  pie: "pie_view",
  table: "table_view"
};

export const view_key_map: any = {
  content_view: "content",
  map_view: "map",
  bar_view: "bar",
  line_view: "line",
  pie_view: "pie",
  table_view: "table"
};

export const supported_views: any = {
  content: true,
  map: true,
  bar: true,
  line: true,
  pie: true
};

const CONTENT_HOVER_CONTENTS = (
  <span>
    The horizontal publication heatmap contains data collected from both
    horizontal (print) publications <br />
    and vertical publications (storefronts) in the Flipp mobile app. Horizontal
    data can be isolated via <br />
    the filtering menu by selecting the hosted channel or desktop as the device.
    For more information <br />
    please contact your account representitive.
  </span>
);



// WEBPACK FOOTER //
// ./client/modules/AnalyticsMetric/components/Dropdown/ViewSelect/index.tsx